import { useEffect } from 'react';

export const useUnloadPrompt = (when: boolean): void => {
	useEffect(() => {
		if (!when) return;

		const handler = (event: BeforeUnloadEvent) => {
			event.preventDefault();
			event.returnValue = '';
		};

		window.addEventListener('beforeunload', handler);
		return () => window.removeEventListener('beforeunload', handler);
	}, [when]);
};
